import _ from "lodash";
import { GFA_DATA_MAP } from "lib/constants";
import { storageService } from "lib/utils/localStorage";
import { getScheduleKey } from "./getScheduleKey";

export type PipelineDataType = {
  email?: string;
  event_type?: string | null;
  identifier?: string | null;
  role?: string | null;
  sales_plan_type?: string;
  source?: string | null;
  token?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_context?: string;
  utm_medium?: string;
  utm_source?: string;
  utm_term?: string;
};

type PipelineLocalStorageData = {
  asPath: string;
  data: PipelineDataType;
  nextPipelinePath: string;
};

export const getPipelineLocalStorageData = ({ asPath, data, nextPipelinePath }: PipelineLocalStorageData) => {
  const dataDeepCopy = _.cloneDeep(data);

  dataDeepCopy.token = dataDeepCopy.token || getScheduleKey(nextPipelinePath);
  const localData = storageService.get(dataDeepCopy.token) || {};

  const primaryResourceFromSlug = asPath.split("/", 2).join("/") as keyof typeof GFA_DATA_MAP;
  const parsedGfaData = GFA_DATA_MAP[primaryResourceFromSlug] || {};

  const utmData = storageService.get("gdl_utm")?.data || {};

  const localUtmData = {
    utm_campaign: utmData.name,
    utm_source: utmData.source,
    utm_medium: utmData.medium,
    utm_context: utmData.context,
    utm_term: utmData.term,
    utm_content: utmData.content,
  } as any;

  return {
    ...localData,
    ...localUtmData,
    ...parsedGfaData,
    ...dataDeepCopy, // API data should always override as preferred value
  };
};
